<template>    
    <div class="py-4 container-fluid">
        <div class="row">
            <div class="col-lg-12">                
                <div class="card mb-5">
                    <div class="card-header p-3 pt-2">
                        <div class="icon icon-lg icon-shape shadow text-center border-radius-xl mt-n4 position-absolute bg-gradient-success shadow-dark">
                            <i class="material-icons opacity-10 text-white" aria-hidden="true">domain</i>
                        </div>
                        <h6 class="mb-2" style="margin-left: 4.5rem !important;">Register species</h6>
                        <div class="row" style="margin-top: -30px;">
                            <div class="col-lg-6">
                            </div>
                            <div class="text-right col-lg-6 d-flex flex-column justify-content-center">
                                <router-link to="/register/create" class="mt-2 mb-0 btn bg-gradient-success btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0" title="Add register">Add register</router-link>
                            </div>
                        </div>                         
                    </div>
                    <div class="table-responsive">
                        <error v-if="error" :error="error" />
                        <table id="register-list" class="table table-flush">
                            <thead class="thead-light">
                                <tr>
                                    <th><p class="mb-0 text-xs font-weight-bold">Email</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">Name</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">Species</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">Address</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">City, Zipcode</p></th>
                                    <th><p class="mb-0 text-xs font-weight-bold">Telephone/Mobile</p></th>
                                    <th></th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="register in registers" v-bind:key="register.id">
                                    <td class="text-sm font-weight-normal">{{ register.email }}</td>
                                    <td class="text-sm font-weight-normal">{{ register.displayName }}</td>
                                    <td class="text-sm font-weight-normal">{{ register.animalSpecies }}</td>
                                    <td class="text-sm font-weight-normal">{{ register.address }}</td>
                                    <td class="text-sm font-weight-normal">{{ register.city	}}, {{ register.zipcode	}}</td>
                                    <td class="text-sm font-weight-normal">{{ register.telephoneNumber }}/{{ register.mobileNumber }}</td>
                                    <td>
                                        <div class="float-end">
                                            <button :data-id="register.id" class="mt-2 mb-0 btn btn-sm bg-gradient-success ms-lg-auto me-lg-0 me-auto mt-lg-0 edit-button" style="margin-right: 10px !important;" title="Edit user">
                                                <i class="material-icons opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">edit</i>
                                            </button>
                                            <button :data-id="register.id" class="mt-2 mb-0 btn bg-gradient-danger btn-sm ms-lg-auto me-lg-0 me-auto mt-lg-0 delete-button" title="Delete register">
                                                <i class="material-icons opacity-10 text-white" style="font-size: 0.8rem;" aria-hidden="true">delete</i>
                                            </button>
                                        </div>
                                    </td>          
                                </tr>                                            
                            </tbody>
                        </table>
                    </div>
                </div>
            </div>
        </div>

        <div class="row"></div>
    </div>        
</template>

<script>
import axios from 'axios'
import { nextTick } from 'vue';
import { DataTable } from "simple-datatables";
import Error from '../../components/GlobalAlert.vue'

export default {
    name: 'Register_index_page',    
    components: {
        Error
    },
    data() {
        return {
            registers: [],
            gets: [],
            error: ''
        }
    },
    async mounted() {
        try {
            this.$store.commit('setShowLoading', true);

            const response = await axios.get("Register/getall");
            this.gets = response.data;

            if (this.gets.success) {
                this.registers = this.gets.data;
            } else {
                this.error = 'Oops!! Error contact system admin.';
            }
            
            await nextTick();  // Wait until the DOM is updated

            new DataTable("#register-list", {
                searchable: true,
                fixedHeight: false,
                perPageSelect: false,
                perPage: 2, // Set the default number of records per page
                //perPageSelect: [5, 10, 20, 50], // Adds a dropdown with options
                columns: [
                    { select: 0, sortable: true },  // Email column (index 0)
                    { select: 1, sortable: true },  // Name column (index 1)
                    { select: 2, sortable: true },  // Species column (index 2)
                    { select: 3, sortable: true },  // Address column (index 3)
                    { select: 4, sortable: true },  // City, Zipcode column (index 4)
                    { select: 5, sortable: true },  // Telephone/Mobile column (index 5)
                    { select: 6, sortable: false }  // Action column (index 6) - Disable sorting
                ]
            });  
            
            document.querySelector('#register-list').addEventListener('click', (event) => {    
                 // Use closest to find an element with data-id in the DOM tree
                const targetElement = event.target.closest('[data-id]');
    
                if (!targetElement) return; // No element with data-id found
                const id = targetElement.getAttribute('data-id');

                if (id === null) {
                    alert('ID is null');
                    return;
                }

                if(id) {
                    if (event.target.closest('.edit-button')) {
                        this.$router.push({ name: 'Edit Register', params: { id: id } });
                    } else if (event.target.classList.contains('delete-button')) {
                        this.deleteRegisterModal(id);
                    }
                }
            });
        } catch (e) {
            this.error = 'Oops!! Error contact system admin.';
        } finally {
            this.$store.commit('setShowLoading', false);
        }
        
        
        this.$store.commit('setShowLoading', false);
    },
    methods: {
        
        async deleteRegisterModal(id) {   
            this.$swal
                .fire({
                    text: "Are you sure to delete the register?",
                    icon: "error",
                    cancelButtonText: "Cancel",
                    confirmButtonText: "Yes, Confirm Delete",
                    showCancelButton: true,
                })
                .then(async (result) => {
                    if (result["isConfirmed"]) {
                        // Put delete logic
                        try {
                            
                            this.$store.commit('setShowLoading', true);

                            const response = await axios.delete("Register/" + id);
                            this.gets = response.data;

                            if (this.gets.success) {
                                const response = await axios.get("Register/getall");
                                this.gets = response.data;

                                if (this.gets.success) {
                                    this.registers = this.gets.data;
                                } else {
                                    this.error = 'Oops!! Error contact system admin.';
                                }
                            } else {
                                this.error = 'Oops!! Error contact system admin.';
                            }
                        } catch (e) {
                            this.error = 'Oops!! Error contact system admin.';
                        }
                        
                        this.$store.commit('setShowLoading', false);
                        this.$swal.fire({
                            text: "Success, Register has been deleted.",
                            icon: "success",
                            position: 'top-end',
                            timer: 1000,
                        });
                    }
                });            
        }
    }
}
</script>
<style scoped>
    /* Ensure the top container uses flex layout */
    ::v-deep .dataTable-top {
        display: flex !important;
        justify-content: flex-start !important;
        align-items: center !important;
    }

    /* Specifically target the search box to stay left aligned */
    ::v-deep .dataTable-top .dataTable-search {
        margin-right: auto !important;
        width: 50% !important;
    }

    ::v-deep .dataTable-top .dataTable-search .dataTable-input {
        width: 100% !important;
    }

    ::v-deep .dataTable-wrapper .dataTable-top .dataTable-search input {
        border: 1px solid #d2d2d2 !important;
    }

    /* Adjust the dropdown positioning (if present) */
    ::v-deep .dataTable-top .dataTable-dropdown {
        margin-left: 10px !important;
    }
</style>